import React, { Suspense, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import OurRoutes from './Routes';
import * as Routers from './Routers';
import Header from '../components/header';
import { CartProvider } from '../context/CartContext';

// Wraps the routing logic and header display
const AppRouterWrapper = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const location = useLocation();

  const hideHeaderRoutes = [OurRoutes.LOGIN, OurRoutes.SIGNUP, '/'];
  const shouldShowHeader = !hideHeaderRoutes.includes(location.pathname);

  return (
    <>
      {shouldShowHeader && (
        <Header searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      )}

      <Routes>
        <Route path={OurRoutes.LOGIN} element={<Routers.LOGIN />} />
        <Route path={OurRoutes.SIGNUP} element={<Routers.SIGNUP />} />
        <Route path={OurRoutes.CREATOR} element={<Routers.Homepage searchTerm={searchTerm}  />} />
        <Route path={OurRoutes.DISCOVER} element={<Routers.DISCOVER />} />
        <Route path={OurRoutes.ADDTOCART} element={<Routers.ADDTOCART />} />
        <Route path={OurRoutes.CHECKOUT} element={<Routers.CHECKOUT />} />
        <Route path={OurRoutes.ADDRESSE} element={<Routers.ADDRESSE />} />
        <Route path={OurRoutes.PRODUCT_DETAILS} element={<Routers.PRODUCT_DETAILS />} />
        <Route path={OurRoutes.DETAILS} element={<Routers.DETAILS />} />
        <Route path={OurRoutes.PROFILE} element={<Routers.PROFILE />} />
        <Route path={OurRoutes.USER_PROFILE} element={<Routers.USER_PROFILE />} />
        <Route path={OurRoutes.USER_PRODUCTS} element={<Routers.USER_PRODUCTS />} />
        <Route path={OurRoutes.RETURN_AND_REFUND} element={<Routers.RETURN_AND_REFUND />} />
        <Route path={OurRoutes.STYLES} element={<Routers.STYLES />} />
        <Route path={OurRoutes.MY_ACCOUNT} element={<Routers.MY_ACCOUNT />} />
        <Route path={OurRoutes.MY_ADDRESS} element={<Routers.MY_ADDRESS />} />
        <Route path={OurRoutes.CHANGE_PASSWORD} element={<Routers.CHANGE_PASSWORD />} />
        <Route path={OurRoutes.FORGOT_PASSWORD} element={<Routers.FORGOT_PASSWORD />} />
        <Route path={OurRoutes.NOTIFY} element={<Routers.NOTIFY />} />
        <Route path={OurRoutes.MY_CART} element={<Routers.MY_CART />} />
        <Route path={OurRoutes.DISCOVER_DETAILS} element={<Routers.DISCOVER_DETAILS />} />
      </Routes>
    </>
  );
};

const AppRouter = () => (
  <Router>
    <CartProvider>
      <Suspense fallback={<div>Loading...</div>}>
        <AppRouterWrapper />
      </Suspense>
    </CartProvider>
  </Router>
);

export default AppRouter;
